import { useTranslation } from '../hooks/useTranslation';

export function SEOContent() {
  const { t } = useTranslation();

  return (
    <div className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        {/* FAQ Section */}
        <section className="mb-20">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4">
              {t('seo.faq_title')}
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              {t('seo.faq_subtitle')}
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="space-y-6">
              {[
                {
                  q: t('seo.faq1_q'),
                  a: t('seo.faq1_a')
                },
                {
                  q: t('seo.faq2_q'),
                  a: t('seo.faq2_a')
                },
                {
                  q: t('seo.faq3_q'),
                  a: t('seo.faq3_a')
                },
                {
                  q: t('seo.faq4_q'),
                  a: t('seo.faq4_a')
                },
                {
                  q: t('seo.faq5_q'),
                  a: t('seo.faq5_a')
                },
                {
                  q: t('seo.faq6_q'),
                  a: t('seo.faq6_a')
                },
                {
                  q: t('seo.faq7_q'),
                  a: t('seo.faq7_a')
                },
                {
                  q: t('seo.faq8_q'),
                  a: t('seo.faq8_a')
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
                  <h3 className="text-lg font-semibold text-slate-900 mb-3">
                    {faq.q}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Keywords Section */}
        <section className="bg-gradient-to-r from-emerald-500 to-cyan-500 rounded-2xl p-8 text-white">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold mb-4">
              {t('seo.keywords_title')}
            </h2>
            <p className="text-emerald-50 text-lg">
              {t('seo.keywords_subtitle')}
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-3">
            {[
              t('seo.keyword1'), t('seo.keyword2'), t('seo.keyword3'), t('seo.keyword4'),
              t('seo.keyword5'), t('seo.keyword6'), t('seo.keyword7'), t('seo.keyword8'),
              t('seo.keyword9'), t('seo.keyword10'), t('seo.keyword11'), t('seo.keyword12'),
              t('seo.keyword13'), t('seo.keyword14'), t('seo.keyword15'), t('seo.keyword16')
            ].map((keyword, index) => (
              <span 
                key={index}
                className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/30 transition-colors cursor-pointer"
              >
                {keyword}
              </span>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
}
